/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/inline-script-id */
import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import Router from 'next/router'
import Script from 'next/script'
import { GeistProvider, CssBaseline, Themes } from '@geist-ui/react'
import Container from '../layouts/Container'

import '../styles.css'

const onRedirectCallback = (appState) => {
  Router.replace(appState?.returnTo || '/')
}

function MyApp({ Component, pageProps }) {
  const breakpoints = {
    xs: { min: '0', max: '650px' },
    sm: { min: '650px', max: '1000px' },
    md: { min: '1000px', max: '1425px' },
    lg: { min: '1425px', max: '1920px' },
    xl: { min: '1920px', max: '10000px' },
  }

  const myTheme = Themes.createFromLight({
    type: 'myTheme',
    breakpoints,
    palette: {
      error: '#ff8a85',
      secondary: '#fff',
    },
  })

  return (
    <>
      {/* OLD ----- Google Tag Manager (noscript)  */}
      {/* <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-M82J4LC"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript> */}
      {/* End Google Tag Manager (noscript)  */}

      {/* Meta site tag  */}
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '401467124965843');
                    fbq('track', 'PageView');
                  `,
        }}
      />
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=401467124965843&ev=PageView&noscript=1"
        />
      </noscript>

      {/* Global site tag (gtag.js) - Google Ads  */}
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=AW-10796135418"
      />
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'AW-10796135418');
                  `,
        }}
      />
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-M82J4LC');
                  `,
        }}
      />

      {/* GA-4 Tag */}
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-66QD9B06YW"
      />
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date()); 
                    
                    gtag('config', 'G-66QD9B06YW');
                  `,
        }}
      />
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-M82J4LC');
                  `,
        }}
      />

      {/* Hotjar  */}
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                  (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:2646007,hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                  `,
        }}
      />
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          (function(win, doc, sdk_url){
            if(win.ndp) return;
            var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
          };
            tr.queue = [];
            var s='script';
            var new_script_section=doc.createElement(s);
            new_script_section.async=!0;
            new_script_section.src=sdk_url;
            var insert_pos=doc.getElementsByTagName(s)[0];
            insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
          })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');

            ndp('init','7e46c2e4-dae2-4a89-b799-e50e312186a3', {})
            ndp('track','PAGE_VIEW');
    `,
        }}
      />
      <Auth0Provider
        domain="auth.waterproplan.com"
        clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}
        audience="https://portal/"
        redirectUri={typeof window !== 'undefined' && window.location.origin}
        onRedirectCallback={onRedirectCallback}
      >
        <GeistProvider themes={[myTheme]} themeType="myTheme">
          <CssBaseline />
          <Container>
            <Component {...pageProps} />
          </Container>
        </GeistProvider>
      </Auth0Provider>
    </>
  )
}

export default MyApp
